@if (visible) {
  @if (expanded) {
    <div class="cc-scrim" [@ccFade] [@.disabled]="reduceMotion" (click)="closeSettings()" aria-hidden="true"></div>
  }
  <section class="cc-sheet" role="dialog" aria-labelledby="cc-title" [attr.aria-modal]="expanded"
    [cdkTrapFocus]="expanded" [@ccSlide] [@.disabled]="reduceMotion">
    <!-- ── Compact view ─────────────────────────────────────────────────────── -->
    @if (!expanded) {
      <div class="cc-view cc-compact">
        <div class="cc-compact__text">
          <div class="cc-head">
            <span class="cc-icon" aria-hidden="true"><ion-icon name="shield-checkmark-outline"></ion-icon></span>
            <h2 id="cc-title" class="cc-title">{{ 'cookieConsent.title' | translate }}</h2>
          </div>
          <p class="cc-desc">
            {{ 'cookieConsent.compactDesc' | translate }}
            <a routerLink="/privacy" class="cc-link" (click)="visible = false">{{
              'cookieConsent.privacyLink' | translate
            }}</a>
          </p>
        </div>
        <div class="cc-compact__actions">
          <div class="cc-pair">
            <button type="button" class="cc-btn cc-btn--neutral" (click)="acceptEssential()">
              {{ 'cookieConsent.essentialOnly' | translate }}
            </button>
            <button type="button" class="cc-btn cc-btn--primary" (click)="acceptAll()">
              {{ 'cookieConsent.acceptAll' | translate }}
            </button>
          </div>
          <button type="button" #customizeBtn class="cc-link-btn" (click)="showSettings()">
            {{ 'cookieConsent.customize' | translate }}
            <ion-icon name="chevron-up-outline" aria-hidden="true"></ion-icon>
          </button>
        </div>
      </div>
    } @else {
      <!-- ── Settings view ──────────────────────────────────────────────────── -->
      <div class="cc-view cc-settings">
        <header class="cc-settings__head">
          <span class="cc-icon" aria-hidden="true"><ion-icon name="shield-checkmark-outline"></ion-icon></span>
          <h2 id="cc-title" #settingsTitle class="cc-title" tabindex="-1">
            {{ 'cookieConsent.settingsTitle' | translate }}
          </h2>
          <button
            type="button"
            class="cc-close"
            (click)="closeSettings()"
            [attr.aria-label]="'cookieConsent.close' | translate"
          >
            <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
          </button>
        </header>

        <div class="cc-scroll">
          <p class="cc-desc">
            {{ 'cookieConsent.settingsDesc' | translate }}
            <a routerLink="/privacy" class="cc-link" (click)="visible = false">{{
              'cookieConsent.privacyLink' | translate
            }}</a>
          </p>

          <ul class="cc-cats">
            @for (cat of categories; track cat.id) {
              <li class="cc-cat">
                @if (cat.id !== 'essential') {
                  <label class="cc-cat__row cc-cat__row--switch">
                    <span class="cc-cat__icon" aria-hidden="true"><ion-icon [name]="cat.icon"></ion-icon></span>
                    <span class="cc-cat__text">
                      <span class="cc-cat__name" [id]="'cc-name-' + cat.id">{{ cat.nameKey | translate }}</span>
                      <span class="cc-cat__desc" [id]="'cc-desc-' + cat.id">{{ cat.descKey | translate }}</span>
                    </span>
                    <input type="checkbox" role="switch" class="cc-switch__input" [checked]="choices[cat.id]"
                      [attr.aria-label]="cat.switchLabelKey | translate" [attr.aria-describedby]="'cc-desc-' + cat.id"
                      (change)="onChoiceChange(cat.id, $event)" />
                    <span class="cc-switch" aria-hidden="true"></span>
                  </label>
                } @else {
                  <div class="cc-cat__row">
                    <span class="cc-cat__icon" aria-hidden="true"><ion-icon [name]="cat.icon"></ion-icon></span>
                    <span class="cc-cat__text">
                      <span class="cc-cat__name" [id]="'cc-name-' + cat.id">{{ cat.nameKey | translate }}</span>
                      <span class="cc-cat__desc" [id]="'cc-desc-' + cat.id">{{ cat.descKey | translate }}</span>
                    </span>
                    <span class="cc-badge">{{ 'cookieConsent.alwaysOn' | translate }}</span>
                  </div>
                }

                <button type="button" class="cc-details-btn" [attr.aria-expanded]="isOpen(cat.id)"
                  [attr.aria-describedby]="'cc-name-' + cat.id"
                  [attr.aria-controls]="isOpen(cat.id) ? 'cc-details-' + cat.id : null" (click)="toggleDetails(cat.id)">
                  <span>{{
                    (isOpen(cat.id) ? 'cookieConsent.hideDetails' : 'cookieConsent.showDetails') | translate
                  }}</span>
                  <ion-icon name="chevron-down-outline" class="cc-chevron" [class.cc-chevron--open]="isOpen(cat.id)"
                    aria-hidden="true"></ion-icon>
                </button>

                @if (isOpen(cat.id)) {
                  <ul class="cc-cookies" [id]="'cc-details-' + cat.id">
                    @for (cookie of cat.cookies; track cookie.name) {
                      <li class="cc-cookie">
                        <code class="cc-cookie__name">{{ cookie.name }}</code>
                        <dl class="cc-cookie__meta">
                          <dt>{{ 'cookieConsent.colProvider' | translate }}</dt>
                          <dd>{{ cookie.provider }}</dd>
                          <dt>{{ 'cookieConsent.colPurpose' | translate }}</dt>
                          <dd>{{ cookie.purposeKey | translate }}</dd>
                          <dt>{{ 'cookieConsent.colExpiry' | translate }}</dt>
                          <dd>{{ cookie.expiryKey | translate }}</dd>
                        </dl>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        </div>

        <footer class="cc-footer">
          <button type="button" class="cc-btn cc-btn--primary" (click)="saveCustom()">
            {{ 'cookieConsent.saveSelection' | translate }}
          </button>
          <div class="cc-pair">
            <button type="button" class="cc-btn cc-btn--neutral" (click)="acceptEssential()">
              {{ 'cookieConsent.essentialOnly' | translate }}
            </button>
            <button type="button" class="cc-btn cc-btn--neutral" (click)="acceptAll()">
              {{ 'cookieConsent.acceptAll' | translate }}
            </button>
          </div>
        </footer>
      </div>
    }
  </section>
}
